import React from "react";
import Modal from "react-bootstrap/lib/Modal";
import { connect } from "react-redux";
import Button from "react-bootstrap/lib/Button";
//import Iframe from "react-iframe";
import NetTask from "../../../requests/tasks/net/netTask";
import {LOCAL_STORAGE_LOGGED_USER, GetRegion} from "../../../constants";
import RequestManager from "../../../requests/RequestManager";
import NetWFTask from "../../../requests/tasks/net/netWFTask";
const classButtonInactive = "btn btn-default close-modal ";
import * as actions from "../../../actions/response";
import { converter } from "../../../helpers/converter";
import PaywayConfirmTask from "../../../requests/tasks/PaywayConfirmTask";

import NavUtils from '../../../utils/nav/Utils';
import qs from 'query-string';
import ClaroUrlBuilder from "../../../utils/ClaroUrlBuilder";

class ModalNetVendorsRegister extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { frame: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.closeModal("NetVendorsRegister");
    window.location = ClaroUrlBuilder.register();
   /* return this.props.showModal({
      modalType: "Cpf"
    });*/
  }

  UNSAFE_componentWillMount() {
    if (this.props.__forceShowFrame) {
      this.showIframe();
    }
  }

  openExternalNet() {
    localStorage.getItem("net_purchase_url")
      ? window.open(localStorage.getItem("net_purchase_url"))
      : window.open("http://servicos.netcombo.com.br");
  }
  confirmNetStart() {
    let customEndPoint = localStorage.getItem("loginInfo.netPurchaseURL");
    let netWFTask = new NetWFTask({ customEndPoint });
    RequestManager.addRequest(netWFTask)
      .then(result => {
        result.response.list.forEach(
          function(data) {
            if (data.gateway == "netgate") {
              let url = data.buyLink;
              let pwTask = new PaywayConfirmTask(url);
              RequestManager.addRequest(pwTask)
                .then(result => {
                })
                .catch(err => {
                  const message =
                    this.props.translations.net_msj_error_sinsucripcion ||
                    err.message;
                  const modalOptions = {
                    modalType: "ErrorSimple",
                    props: {
                      message: message,
                      onAccept: modalScope => {
                        if (this.props.__forceConfirm) {
                          modalScope.closeModal();
                          return;
                        }
                        window.location.reload();
                      }
                    }
                  };
                  this.props.showModal(modalOptions);
                });
            }
          }.bind(this)
        );
      })
      .catch(err => {
        this.setState({ waiting: false });
        const buttonMessage = converter.convertApaUnicode(
          this.props.translations,
          "registro_aceptar"
        );
        const message = converter.convertApaUnicode(
          this.props.translations,
          "bad_response_error_msg"
        );
        const modal = {
          modalType: "ErrorSimple",
          props: {
            message,
            onAccept: () => {
              this.props.closeModal("ErrorSimple");
            }
          }
        };

        this.props.showModal(modal);
      });
  }

  closeModal() {
    this.props.closeModal("NetVendorsRegister");
  }

  showIframe(test, url) {
    if (test == "default") return this.handleClick();
    if (url) window.purchase_url = url;
    const _this = this;

    window.MessageHandler = function(event) {
      _this.closeModal();
      const modalOps = {
        modalType: 'SuccessSimple',
        props: {
          message: converter.convertApaUnicode(
              _this.props.translations,
              "net_success_ful_validation_msg",
              "Parabéns! Agora você já pode aproveitar o Claro video. Você receberá um e-mail de confirmação no endereço: {@USERNAME}."
          ).replace('{@USERNAME}', JSON.parse(localStorage.getItem("loginInfo.logged_user_data")).username),
          onAccept: () => {
            location.reload();
          },
          onClose: () => {
            location.reload();
          }
        }
      };
      _this.props.showModal(modalOps);
    };

    let netTask = new NetTask({
      region: GetRegion(),
      callback_fe: "webcallback",
      socialnetwork: "NET"
    });

    RequestManager.addRequest(netTask)
      .then(result => {
        const { redirectUrl } = result.response;
        const pdRctUrl = NavUtils.parseUrl(redirectUrl);
        const params = qs.parse(pdRctUrl.search);
        const pdCbUrl = NavUtils.parseUrl(params.redirect_uri); // Url callback
        const pdHtUrl = NavUtils.parseUrl(window.location.href); // Url local
      //Rewrite url to use the local url
      //params.redirect_uri = `${pdHtUrl.protocol}//${pdHtUrl.host}${pdHtUrl.port ? `:${pdHtUrl.port}` : ""}${pdCbUrl.pathname}${pdCbUrl.search}${pdCbUrl.hash}`;
         params.redirect_uri= `${pdCbUrl.protocol}//${pdCbUrl.hostname}${pdCbUrl.pathname}${pdCbUrl.search}${pdCbUrl.hash}`;
         params.redirect_uri= params.redirect_uri.replace(".comnet",".com/net")

        const search = `?${qs.stringify(params)}`;

        let urlFrame= `${pdRctUrl.protocol}//${pdRctUrl.hostname}${pdRctUrl.pathname}${search}${pdRctUrl.hash}`;
        urlFrame= urlFrame.replace(".brauth", ".br/auth")

        this.setState({ frame: true, urlFrame });
      })
      .catch(err => {
        this.setState({ waiting: false });
        const buttonMessage = converter.convertApaUnicode(this.props.translations, "registro_aceptar");
        const message = converter.convertApaUnicode(this.props.translations, "bad_response_error_msg");
        const modalOptions = { visibility: true, message, type: "error", title: "", button: [{ active: true, message: buttonMessage, callback: scopeModal => {
                scopeModal.closeModal();
              } }], positionButtons: "flex-end" };
        this.props.showModal(modalOptions);
      });
  }

  render() {
    const netButtonsClass = `col-lg-12 col-md-12 col-sm-12 col-xs-12`;
    const pro = JSON.parse(this.props.metadata.login_providers);

    if (this.props.__forceConfirm) {
      return (
        <Modal show={true}>
          <Modal.Header
            style={{
              "border-top-left-radius": "6px",
              "border-top-right-radius": "6px",
              "background-color": "white",
              color: "black",
              "font-size": "x-large "
            }}
            className="text-center"
          >
            <Button
              className="close close-modal net-close"
              style={{
                color: "black"
              }}
              onClick={this.closeModal}
            >
              x
            </Button>

            {converter.convertApaUnicode(
              this.props.translations,
              "net_nosusc_titulo",
              "No Identificamos tu Suscripcion"
            )}

            <h4 className="modal-title text-center">
              {converter.convertApaUnicode(
                this.props.translations,
                "net_nosusc_instrucciones",
                "Seleccciona una Opcion"
              )}
            </h4>
          </Modal.Header>
          <Modal.Body
            style={{
              height: "150px",
              padding: "30px 0px",
              "background-color": "white"
            }}
          >
            <a
              className="btn btn-primary btn-lg btn-block padding-right-left-10"
              onClick={this.openExternalNet.bind(this)}
              style={{
                width: "80%",
                "top:": "50px",
                left: "10%",
                position: "relative"
              }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                "net_nosusc_asociar",
                "Debes seleccionar un servicio de NET"
              )}
            </a>
            <a
              className="btn btn-primary btn-lg btn-block padding-right-left-10"
              onClick={this.confirmNetStart.bind(this)}
              style={{
                width: "80%",
                left: "10%",
                position: "relative"
              }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                "net_nosusc_confirmacion",
                "Debes seleccionar un servicio de NET"
              )}
            </a>
          </Modal.Body>
        </Modal>
      );
    }
    if (this.state.frame || this.props.__forceShowFrame) {
      return (
        <Modal show={true}>
          <Modal.Body
            style={{
              height: "400px",
              padding: "0px"
            }}
          >
            <iframe
              src={this.state.urlFrame}
              className="net-iframe"
              height={"100%"}
              width={"100%"}
              style={{
                "border-radius": "6px"
              }}
            />
            <Button
              className="close close-modal net-close"
              style={{
                right: "-5px",
                top: "-5px",
                position: "absolute",
                "background-color": "white",
                color: "black",
                "border-radius": "9px",
                width: "20px",
                "text-align": "center",
                "z-index": "5",
                "text-decoration": "none"
              }}
              onClick={this.closeModal}
            >
              x
            </Button>
          </Modal.Body>
        </Modal>
      );
    }
    return (
      <Modal show={true}>
        <Modal.Header
          style={{
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            backgroundColor: "#f4f4f4",
            color: "black",
            fontSize: "x-large "
          }}
        >
          <Button
            className="close close-modal net-close"
            style={{
              color: "black"
            }}
            onClick={this.closeModal}
          >
            x
          </Button>
          <h4 className="modal-title text-center">
            {converter.convertApaUnicode(
              this.props.translations,
              "net_operadora_reg",
              "Debes seleccionar un servicio de NET"
            )}
          </h4>
        </Modal.Header>
        <Modal.Body
          className="text-center success"
          style={{
            backgroundColor: "#f4f4f4"
          }}
        >
          <div className={netButtonsClass}>
            {pro.net.providers.map((item, index) => {
              if (index < pro.net.providers.length - 1)
                return (
                  <a
                    className={""}
                    style={{
                      width: "28%",
                      marginLeft: "4%",
                      display: "inline-block",

                      border: "solid black 1px"
                    }}
                    onClick={() =>
                      this.showIframe(item.autenticationType, item.url)}
                    key={index}
                  >
                    <img
                      style={{
                        width: "100%"
                      }}
                      src={this.props.asset[item.img]}
                    />{" "}
                  </a>
                );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderBottomLeftRadius: "6px",
            borderBottomRightRadius: "6px",
            backgroundColor: "#f4f4f4",
            color: "black",
            fontSize: "large ",
            paddingTop: "0px"
          }}
        >
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    asset: state.asset,
    metadata: state.metadata
  };
};

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(
  ModalNetVendorsRegister
);
